<template>
  <i
    class="inline-svg"
    :style="{
      color,
      width
    }"
    @click="$emit('click')"
    v-html="icon"
  />
</template>

<script>
export default {
  name: 'InlineSvg',
  props: {
    icon: {
      type: String,
      default: ''
    },
    // svg fill color
    color: {
      type: String,
      default: ''
    },
    width: {
      type: String,
      default: ''
    }
  }
}
</script>

<style>
.inline-svg {
  display: inline-block;
  font-size: 0;
  line-height: 0;
  vertical-align: middle;
}

.inline-svg svg {
  fill: currentcolor;
}
</style>
